import { useRecoilState } from "recoil"

import preventionAudio from "~/assets/audio/prevention-toast-audio.mp3"
import { designPreventionToastIsOpenState } from "~/containers/LegacyDesigner/state/phase"

export const useTriggerPreventionToast = (): VoidFunction => {
  const [preventionToastIsOpen, setPreventionToastIsOpen] = useRecoilState(
    designPreventionToastIsOpenState,
  )

  const triggerToast = () => {
    if (!preventionToastIsOpen) {
      new Audio(preventionAudio).play()
      setPreventionToastIsOpen(true)
      setTimeout(() => {
        setPreventionToastIsOpen(false)
      }, 3500)
    }
  }

  return triggerToast
}
